import React, { useCallback, useEffect, useRef, useState } from 'react';
import { requestform } from '../../messages';
import { Typography } from 'antd';
import {
  connectNotificationSocket,
  disconnectNotificationSocket,
  offReceiveNotification,
  onReceiveNotification,
  useLazyGetTicketCountQuery
} from '../../services';
import { NOTIFICATION_TYPE, runMeiSeedingOnce } from '../../utils';
import NoSleep from 'nosleep.js';
import dayjs from 'dayjs';
import { getTabsByNotificationType } from '../../utils/helpers/get-tabs-by-notification-type';

const PendingTicketNotification = () => {
  const status = 'pending_reception';

  const [triggerGetTicketCount, { data: countData }] = useLazyGetTicketCountQuery();
  const pendingCount = countData?.data ?? 0;

  // ==== AUDIO STATE ====
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [isAudioUnlocked, setIsAudioUnlocked] = useState(false);

  //! ========================= [1] ĐIỂM MEI (Media Engagement Index) =========================
  const unlockAudioAndSeedMei = useCallback(async () => {
    if (isAudioUnlocked || !audioRef.current) return;
    try {
      audioRef.current.src = '/sound/no-sound.mp3';
      await audioRef.current.play();
      audioRef.current.pause();

      setIsAudioUnlocked(true);
      runMeiSeedingOnce(); // Run to get MEI
    } catch (error) {
      console.error('Audio unlock failed, user interaction is required.', error);
    }
  }, [isAudioUnlocked]);

  //! ================== [2] GẮN LISTENER ĐỂ CHỜ NGƯỜI DÙNG TƯƠNG TÁC (UNLOCK) =================
  // Gắn listener để chờ người dùng tương tác
  useEffect(() => {
    if (isAudioUnlocked) return;
    document.addEventListener('click', unlockAudioAndSeedMei, { once: true });
    document.addEventListener('keydown', unlockAudioAndSeedMei, { once: true });
    unlockAudioAndSeedMei();
    return () => {
      document.removeEventListener('click', unlockAudioAndSeedMei);
      document.removeEventListener('keydown', unlockAudioAndSeedMei);
    };
  }, [isAudioUnlocked, unlockAudioAndSeedMei]);

  // Tạo sẵn 1 audio element và tái sử dụng
  useEffect(() => {
    audioRef.current = new Audio('/sound/beep3.mp3');
    audioRef.current.preload = 'auto';

    // Đừng autoplay ở đây
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
    };
  }, []);

  //! ===================== [3] PHÁT AUDIO NGAY & SAU ĐÓ LẶP LẠI MỖI 120 000ms =====================
  // Phát beep khi có ticket mới (sau khi đã unlock)
  useEffect(() => {
    const playBeep = async () => {
      if (!audioRef.current) return;
      if (!isAudioUnlocked) return;
      try {
        audioRef.current.src = pendingCount > 0 ? '/sound/beep3.mp3' : '/sound/no-sound.mp3';
        audioRef.current.currentTime = 0;
        await audioRef.current.play();
      } catch {}
    };
    playBeep();

    const id = setInterval(playBeep, 10000); // Cứ sau 10s thì phát lại 1 lần cho đến khi không còn phiếu nữa
    return () => clearInterval(id);
  }, [pendingCount, isAudioUnlocked]);

  //  Fetch count
  const fetchCount = () => {
    const fromDate = dayjs().subtract(2, 'month').format('DD/MM/YYYY'); // lấy now tại lúc fetch
    const toDate = dayjs().format('DD/MM/YYYY');

    triggerGetTicketCount({ status, fromDate, toDate })
      .unwrap()
      .then(() => console.log('notification success'))
      .catch(() => console.error('notification failed'));
  };

  useEffect(() => {
    fetchCount();
    const id = setInterval(fetchCount, 120000);
    return () => clearInterval(id);
  }, [triggerGetTicketCount]);

  // Giữ máy không sleep
  useEffect(() => {
    const noSleep = new NoSleep();
    const enableNoSleep = () => {
      noSleep.enable();
      document.removeEventListener('click', enableNoSleep);
    };
    document.addEventListener('click', enableNoSleep);
    return () => {
      document.removeEventListener('click', enableNoSleep);
    };
  }, []);

  // Socket lấy số mới
  useEffect(() => {
    connectNotificationSocket();
    onReceiveNotification();
    return () => {
      disconnectNotificationSocket();
      offReceiveNotification();
    };
  }, []);
  useEffect(() => {
    onReceiveNotification((data) => {
      const fromDate = dayjs().subtract(2, 'month').format('DD/MM/YYYY'); // lấy now tại lúc fetch
      const toDate = dayjs().format('DD/MM/YYYY');
      const relatedTabs = getTabsByNotificationType(data?.type);
      if (relatedTabs.includes('pending_reception') || data.type === NOTIFICATION_TYPE.TICKET) {
        triggerGetTicketCount({ status, fromDate, toDate });
      }
    });
  }, []);

  return (
    <>
      {pendingCount > 0 && (
        <div className='pl-2'>
          <Typography.Text className='item-center flex space-x-2 rounded-full border bg-[#FF9500] p-2'>
            <Typography.Text className='font-bold uppercase text-[#FFFFFF]'>
              Có {pendingCount} {requestform.pendingReceptionTicketNotification}
            </Typography.Text>
          </Typography.Text>
        </div>
      )}
    </>
  );
};
export default PendingTicketNotification;
